<template>
  <div class="header-navbar">
    <ContainerInner class="header-navbar__inner">
      <ElementBrand class="header-navbar__brand" v-if="isDesktop" />
      <TheSearch class="header-navbar__search" v-if="!isDesktop" />
      <TheMenu class="header-navbar__menu" />
    </ContainerInner>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ElementBrand from '@elements/ElementBrand'
import ContainerInner from '@containers/ContainerInner'
import TheMenu from '@blocks/menu/TheMenu'
import TheSearch from '@blocks/search/TheSearch'

export default {
  name: 'TheHeaderNavbar',
  components: {
    TheMenu,
    TheSearch,
    ContainerInner,
    ElementBrand
  },
  computed: {
    ...mapGetters({
      device: 'breakpoints/getDevice'
    }),
    isDesktop () {
      return this.device === 'desktop'
    }
  }
}
</script>

<style lang="scss">
  .header-navbar{
    @include media("small-medium"){
      padding-bottom: 0;
    }

    position: relative;
    background-color: colors("background");
    padding-top: layout("spacing")/2;
    padding-bottom: layout("spacing")/2;

    &.is-open{
      padding-bottom: 0;
    }

    // Inner

    &__inner{
      @include media("small-medium"){
        flex-wrap: wrap;
        padding: 0;
      }

      display: flex;
      justify-content: space-between;
      align-items: center;

      > *:not(.search){
        flex: 0 1 auto;
      }

      .search{
        flex: 1 1 auto;
      }
    }

    // Brand

    &__brand{
      @include media("small-medium"){
        width: 17.2rem;
        height: 8rem;
      }
      @include media("large"){
        width: 20rem;
        height: 9.3rem;
        flex: 0 1 auto;
      }
    }

    // Menu

    &__menu{
      @include media("large"){
        flex: 0 1 auto;
      }
    }
  }
</style>
